import { isNullOrUndefined } from 'util';

import React from 'react';

import { Event } from '../interfaces';
import { useVehicles } from '../queries';

export function VehicleName(props: { event: Event }) {
  const { data: vehicles } = useVehicles();
  const { event } = props;

  if (event?.vehicle_name) {
    return <>{event.vehicle_name}</>;
  }

  if (!isNullOrUndefined(event?.vehicle_id)) {
    const v = vehicles?.find((v) => v.id === event.vehicle_id);
    return <>{v?.name ?? '-'}</>;
  }

  return <>-</>;
}
